import { ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { invertRecordOfArrays } from '../invert-record-of-arrays';
export let Experience = /*#__PURE__*/function (Experience) {
  Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
  Experience["RENDER_JOIN_SECTION"] = "render-join-section";
  Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
  Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
  return Experience;
}({});
export const EXPERIENCE_CONFIGS = {
  [Experience.RENDER_CUSTOM_LINKS_SECTION]: {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad
  },
  [Experience.RENDER_JOIN_SECTION]: {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad
  },
  [Experience.RENDER_SWITCH_TO_SECTION]: {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad
  },
  [Experience.RENDER_SWITCHER_EMPTY_STATE]: {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.PageSegmentLoad
  }
};
export let ExperienceMark = /*#__PURE__*/function (ExperienceMark) {
  ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
  ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
  ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
  ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
  ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
  ExperienceMark["API_PERMISSIONS"] = "api-permissions";
  ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
  ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
  ExperienceMark["TEST_MARK"] = "test-mark";
  return ExperienceMark;
}({});
const allNonTestExperienceMarks = Object.values(ExperienceMark).filter(mark => mark !== ExperienceMark.TEST_MARK);
export const EXPERIENCES_TO_MARKS = {
  [Experience.RENDER_CUSTOM_LINKS_SECTION]: allNonTestExperienceMarks,
  [Experience.RENDER_JOIN_SECTION]: allNonTestExperienceMarks,
  [Experience.RENDER_SWITCH_TO_SECTION]: allNonTestExperienceMarks,
  [Experience.RENDER_SWITCHER_EMPTY_STATE]: allNonTestExperienceMarks
};
export const MARKS_TO_EXPERIENCES = invertRecordOfArrays(EXPERIENCES_TO_MARKS);
export let ExperienceMarkPhase = /*#__PURE__*/function (ExperienceMarkPhase) {
  ExperienceMarkPhase["START"] = "start";
  ExperienceMarkPhase["END"] = "end";
  return ExperienceMarkPhase;
}({});
export let AbortReason = /*#__PURE__*/function (AbortReason) {
  AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
  AbortReason["WINDOW_UNLOADING"] = "window-unloading";
  return AbortReason;
}({});
export const SWITCHER_RENDER_START_PERFORMANCE_MARK = 'atlassianSwitcher.render.start';